import axios from 'axios';

//
const config = {
    clientId: "956858541359104030"
}

//
export function signInWithDiscord(baseUrl: string) {
    let redirectUrl = baseUrl + "/login/discord";

    let authLink = `https://discord.com/oauth2/authorize?client_id=${config.clientId}&redirect_uri=${redirectUrl}&response_type=token&scope=identify`;
    window.open(authLink, "_self");
}

//
export async function loginDiscord(discordAccessToken: string) {
    let reqOptions = {
        headers: {
            'Content-type': 'application/json'
        }
    }

    let reqData = { discordAccessToken };

    try {
        let res = await axios.post(`${process.env.NEXT_PUBLIC_GATE}/login/discord`, reqData, reqOptions);
        console.log("_RES_")
        console.log(res);

        return res;
    }
    catch (e) {
        console.log("_ERROR2");
        console.error(e);
    }
}

//
export async function linkDiscord(discordAccessToken: string, userAccessToken: string) {
    let reqOptions = {
        headers: {
            'Content-type': 'application/json',
            'Authorization': userAccessToken
        }
    }

    let reqData = { discordAccessToken };

    try {
        let res = await axios.post(`${process.env.NEXT_PUBLIC_GATE}/link/discord`, reqData, reqOptions);
        console.log("_RES_")
        console.log(res);

        return res;
    }
    catch (e) {
        console.log("_ERROR");
        console.error(e);
    }
}